import { defaultWeb3ErrorMessages } from '../error-messages/defaultWeb3ErrorMessages';
import { web3AuthErrorMessages } from '../error-messages/web3ErrorMessages';

export const web3ErrorToastMappings: Record<string, string> = {
    [defaultWeb3ErrorMessages.USER_REJECTED_THE_REQUEST]: web3AuthErrorMessages.CONNECTION_CLOSED_BY_USER,
    [defaultWeb3ErrorMessages.RESOURCE_NOT_AVAILABLE]: web3AuthErrorMessages.ALREADY_PROCESSING,
    [defaultWeb3ErrorMessages.ALREADY_PROCESSING]: web3AuthErrorMessages.ALREADY_PROCESSING,
    [defaultWeb3ErrorMessages.USER_DENIED_MESSAGE_SIGNATURE]: web3AuthErrorMessages.SIGNATURE_CLOSED_BY_USER,
    [defaultWeb3ErrorMessages.PERSONAL_SIGN_ALREADY_PENDING]: web3AuthErrorMessages.ALREADY_PROCESSING,
    [defaultWeb3ErrorMessages.SES_WEAK_MAP_ERROR]: web3AuthErrorMessages.ALREADY_PROCESSING,
    [defaultWeb3ErrorMessages.ALREADY_PENDING_FOR_ORIGIN]: web3AuthErrorMessages.ALREADY_PROCESSING,
};
